import { Box, Button, Card, CardContent, Divider, Typography } from '@mui/material';
import React from 'react';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import MeetingRoomOutlinedIcon from '@mui/icons-material/MeetingRoomOutlined';
import KingBedOutlinedIcon from '@mui/icons-material/KingBedOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SmartphoneOutlinedIcon from '@mui/icons-material/SmartphoneOutlined';
import { usePreRegBookingInfoQuery, useUpdateIsPreCheckinMutation, useUpdateRoomAssignmentMutation } from '../../generated/graphql';
import Loading from '../../Components/Loading/Loading';
import { buildPreCheckInUrl } from '../../Components/helper/preCheckInUrl';

const ORANGE = '#F5822B';
const DARK_BLUE = '#394d86';
const INFO_BG = '#F3F6FC';
const INFO_BORDER = '#D9E2F2';

interface Props {
	RegistrationDetails?: any;
}

export const ConfirmPayment = (props: any) => {
	const { RegistrationDetails	} = props;

	const {
    loading: loadingInfo,
    data: { PreRegBookingInfo } = { PreRegBookingInfo: [] },
  } = usePreRegBookingInfoQuery({
    variables: {
      HotelID: RegistrationDetails?.Booking?.HotelID,
      BookingID: RegistrationDetails?.Booking?.ID,
      RegistrationID: RegistrationDetails?.ID,
      QR: 'true',
    },
    fetchPolicy: 'no-cache',
  });
	
	const currRegistration = PreRegBookingInfo?.result
    ?.map(x => {
      const reg = x?.Registrations?.map(r => {
        if (r.ID === RegistrationDetails?.ID) return r;
      })?.filter(i => i !== undefined);
      return reg;
    })
    ?.filter(i => i !== undefined && i?.length > 0)[0];

	let	passcodeParsed = currRegistration?.[0]?.PassCode ? JSON.parse(currRegistration[0].PassCode) : null;

  return (
		<>
			{loadingInfo && <Loading />}
			
			<Box>
				<Box width="100%" display="block" margin="5px 0 14px 0">
					<Box display="flex" justifyContent="center" marginBottom="8px">
						<TaskAltIcon sx={{ color: 'green', fontSize: '40px' }} />
					</Box>
					<Typography display="flex" justifyContent="center" fontSize="18px" fontWeight={600} sx={{ color: 'green' }}>
						Payment Successful
					</Typography>
					<Typography display="flex" justifyContent="center" fontSize="12px" fontWeight={500}>
						Check-In Completed Successfully
					</Typography>
				</Box>

				<Card
					sx={{
						margin: '5px 0 14px 0',
						borderRadius: '10px',
						boxShadow:
							'0 3px 1px -2px transparent, 2px 4px 4px -2px rgb(0 0 0 / 15%), -2px -1px 4px -2px rgb(0 0 0 / 15%)',
					}}
				>
					<CardContent sx={{ ':last-child': { p: '18px' } }}>
						<Typography
							display="flex"
							justifyContent="center"
							fontSize="16px"
							fontWeight={700}
							sx={{ color: DARK_BLUE, mb: '14px' }}
						>
							Access Passcodes
						</Typography>

						<Box display="flex" alignItems="center" py="10px">
							<MeetingRoomOutlinedIcon sx={{ color: ORANGE, fontSize: '32px', mr: '16px' }} />
							<Box>
								<Typography fontSize="12px" color="text.secondary">
									Main Entrance Door Passcode
								</Typography>
								<Typography fontSize="22px" fontWeight={700} sx={{ color: '#1f2937', letterSpacing: '1px' }}>
									{passcodeParsed?.keyboardPwd ? `${passcodeParsed?.publicDoorPasscode?.keyboardPwd}#` : 'N/A'}
								</Typography>
							</Box>
						</Box>

						<Divider />

						<Box display="flex" alignItems="center" py="10px">
							<KingBedOutlinedIcon sx={{ color: ORANGE, fontSize: '32px', mr: '16px' }} />
							<Box>
								<Typography fontSize="12px" color="text.secondary">
									Room Passcode
								</Typography>
								<Typography fontSize="22px" fontWeight={700} sx={{ color: '#1f2937', letterSpacing: '1px' }}>
									{passcodeParsed?.keyboardPwd ? `${passcodeParsed?.keyboardPwd}#` : 'N/A'}
								</Typography>
							</Box>
						</Box>

						<Divider />

						<Box display="flex" alignItems="center" py="10px">
							<ApartmentOutlinedIcon sx={{ color: ORANGE, fontSize: '32px', mr: '16px' }} />
							<Typography fontSize="14px" color="text.secondary">
								Room Number:{' '}
								<Box component="span" sx={{ color: DARK_BLUE, fontWeight: 700, fontSize: '16px' }}>
									{currRegistration?.[0]?.Room?.RoomNo}
								</Box>
							</Typography>
						</Box>
					</CardContent>
				</Card>

				<Box
					display="flex"
					alignItems="center"
					sx={{
						backgroundColor: INFO_BG,
						border: `1px solid ${INFO_BORDER}`,
						borderRadius: '8px',
						p: '10px 12px',
						mb: '10px',
					}}
				>
					<InfoOutlinedIcon sx={{ color: DARK_BLUE, fontSize: '20px', mr: '10px' }} />
					<Typography fontSize="12px" color="text.secondary">
						A welcome letter with your passcodes has been sent to{' '}
						<Box component="span" sx={{ color: '#2f6df6', fontWeight: 600 }}>
							{currRegistration?.[0]?.Guest?.Contact?.Email}
						</Box>
					</Typography>
				</Box>

				<Box
					display="flex"
					alignItems="center"
					sx={{
						backgroundColor: INFO_BG,
						border: `1px solid ${INFO_BORDER}`,
						borderRadius: '8px',
						p: '10px 12px',
						mb: '16px',
					}}
				>
					<SmartphoneOutlinedIcon sx={{ color: ORANGE, fontSize: '20px', mr: '10px' }} />
					<Typography fontSize="12px" color="text.secondary">
						You can also access your passcodes anytime via the{' '}
						<Box component="span" sx={{ color: DARK_BLUE, fontWeight: 700 }}>
							HotelX Guest App
						</Box>
						.
					</Typography>
				</Box>

				<Button
					fullWidth
					variant="contained"
					onClick={() => {
						localStorage.removeItem('SelectedRoom');
            window.location.href = buildPreCheckInUrl(RegistrationDetails?.Booking?.HotelID, RegistrationDetails?.Booking?.ID);
					}}
					sx={{
						backgroundColor: ORANGE,
						color: '#fff',
						fontWeight: 700,
						textTransform: 'none',
						fontSize: '15px',
						borderRadius: '8px',
						py: '10px',
						boxShadow: 'none',
						':hover': { backgroundColor: '#e0761f', boxShadow: 'none' },
					}}
				>
					Complete
				</Button>
			</Box>
		</>
  );
};
